import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';
import { toast } from 'react-toastify';
import { useAppSelector, selectTenantId } from 'slices/commonSelectors';
import { MicrosoftTemplate } from 'types/template';

export const keys = {
  microsoftTemplates: 'microsoftTemplates',
} as const;

type TeamTemplateResponse = {
  name: string;
  id: string;
};

export const useFetchMicrosoftTemplates = (enabled = true) => {
  const tenantId = useAppSelector(selectTenantId);

  return useQuery<MicrosoftTemplate[]>({
    queryKey: [keys.microsoftTemplates, tenantId],
    queryFn: async () => {
      const response = await axios(config.apiGateway.teamTemplateIds, {
        method: 'POST',
        data: {
          tenantId,
        },
      });

      if (
        response.data?.message &&
        response.data.message === 'No template found'
      ) {
        toast.error('No Teams Saved Templates Found');
        return [];
      }

      if (response.data?.supported === false) {
        return [];
      }

      if (response?.data && response.data.length > 0) {
        return response.data.map((template: TeamTemplateResponse) => ({
          label: template.name,
          value: template.id,
        }));
      }

      return [];
    },
    enabled: !!tenantId && enabled,
  });
};
